import { render, staticRenderFns } from "./ProblemView.vue?vue&type=template&id=2bf22c37&"
import script from "./ProblemView.vue?vue&type=script&lang=js&"
export * from "./ProblemView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports